var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide","mode":"out-in","appear":"","appear-active-class":"fade-active","appear-class":"fade-appear","appear-to-class":"fade-to"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }